import React, { Component } from "react";
import { connect } from 'react-redux';
import * as actionCreators from '../../../../modules/actions/index';
import * as url from '../../../../utils/url';
import MapSeparation from '../../../../components/OrganizationSetup/MapSeparation/MapSeparation';

class MapSeparationSetup extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    window.scrollTo(0, 0);
  }
  componentWillUnmount() {
    this.props.resetMapSeparationStep();
  }
  handleFileUpload = (columns, data, file) => {
      this.props.onFileDataProcessed(columns, data, file);
  }

  handleMatchColumn = (matchedColumn) => {
    this.props.onMatchColumn(matchedColumn);
  }

  render() {
    return (<div className="mb20 mt60">
      <MapSeparation
        onProcessedFileUploadData={this.handleFileUpload}
        onMapSeparationMatchColumn={this.handleMatchColumn}
        {...this.props} />
    </div>);
  }
}

const mapStateToProps = state => {
  return {
    user: state.user.profile,
    mapSeparation: state.mapping.separation
  }
}

const mapDispatchToProps = dispatch => {
	return {
    resetMapSeparationStep: () => dispatch(actionCreators.resetMapSeparationStep()),
    nextStep: () => dispatch(actionCreators.mapSeparationNextStep()),
    goBack : () => dispatch(actionCreators.mapSeparationGoBack()),
    saveAllSeparationMapping : (m) => dispatch(actionCreators.saveAllSeparationMapping(m)),
    onFileDataProcessed: (c,d,f) => dispatch(actionCreators.mapSeparationUploadFileSuccess(c,d,f)),
    onMatchColumn: data => dispatch(actionCreators.mapSeparationMatchColumnSuccess(data))
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(MapSeparationSetup);